import themes from '@bnnvara/themes';
import PropTypes from 'prop-types';
import React from 'react';
import * as S from './styled';
export const Download = ({
  color
}) => /*#__PURE__*/React.createElement(S.Icon, {
  xmlns: "http://www.w3.org/2000/svg",
  "aria-label": "download",
  viewBox: "0 0 64 64",
  width: "32px",
  height: "32px"
}, /*#__PURE__*/React.createElement("g", {
  stroke: "none",
  strokeWidth: "1",
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  fill: color,
  d: "M60,56 L60,60 L4,60 L4,56 L60,56 Z M34.35,4 L34.35,40.34 L45.08,29.62 L47.91,32.44 L32.35,48 L16.09,31.74 L18.92,28.91 L30.35,40.34 L30.35,4 L34.35,4 Z"
})));
Download.propTypes = {
  color: PropTypes.string
};
Download.defaultProps = {
  color: themes.bnnvara.base.white
};